import { createSlice } from "@reduxjs/toolkit";

// Generic slice factory for paginated, sortable, searchable data
const projectSlice = (name, defaultSortField = "createdAt", defaultSortOrder = "desc") => {
  const initialState = {
    pagination: { page: 0, pageSize: 15 },
    sortModel: [{ field: defaultSortField, sort: defaultSortOrder }],
    searchText: "",
  };

  const slice = createSlice({
    name,
    initialState,
    reducers: {
      setPagination: (state, action) => {
        state.pagination = action.payload;
      },
      setSortModel: (state, action) => {
        state.sortModel = action.payload;
      },
      setSearchText: (state, action) => {
        state.searchText = action.payload;
      },
      resetPage: state => {
      state.pagination.page = 0;
    },
      resetState: state => Object.assign(state, initialState),
    },
  });

  return slice;
};


// Customer slices
export const manageCustomerSlice = projectSlice("manageCustomer", "customerName", "asc");
export const detailCustomerSlice = projectSlice("detailCustomer", "customerName", "asc");

// Project slices
export const manageNewProjectsSlice = projectSlice("manageNewProjects", "pro_name", "asc");
export const projectTasksSlice = projectSlice("projectTasks", "pro_name", "asc");


// Export customerReducers
export const customerReducers = {
  manageCustomer: manageCustomerSlice.reducer,
  detailCustomer: detailCustomerSlice.reducer,
};

// Export projectReducers
export const projectReducers = {
  manageNewProjects: manageNewProjectsSlice.reducer,
  projectTasks: projectTasksSlice.reducer,
};